import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar, Button, Input } from 'react-daisyui';

const TopNavbar = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // Determine the type of search query
      if (searchQuery.startsWith('0x') && searchQuery.length === 66) {
        navigate(`/tx/${searchQuery.trim()}`);
      } else if (searchQuery.startsWith('0x') && searchQuery.length === 42) {
        navigate(`/address/${searchQuery.trim()}`);
      } else if (!isNaN(searchQuery)) {
        navigate(`/block/${searchQuery.trim()}`);
      } else {
        // Handle invalid search query
        console.error('Invalid search query');
      }
    }
  };

  return (
    <Navbar className="bg-gray-900 mb-4 rounded-box border border-gray-800 px-4">
      <div className="flex justify-between items-center w-full">
        <div className="flex items-center">
          <img src="/test.png" alt="Berachain Logo" className="h-12 mr-2" />
          <span className="text-white mr-3 font-bold text-3xl">Berachain Scan</span>
          <span className="bg-cyan-400 text-black px-2 py-1 rounded-lg text-s">by BlackNodes</span>
        </div>
        
        <form onSubmit={handleSearch} className="w-full max-w-xl">
          <div className="relative">
            <Input 
              type="text"
              placeholder="Search by Tx Hash / Block / Address"
              className="w-full p-2 pl-4 pr-10 rounded-lg bg-gray-800 text-white border border-gray-700"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Button 
              type="submit" 
              className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-transparent border-none hover:bg-gray-700"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </Button>
          </div>
        </form>
      </div>
    </Navbar>
  );
};

export default TopNavbar;